import React from "react"
import PropTypes from "prop-types"

const CalendarIcon = ({ style }) => (
  <svg viewBox="0 0 20 20" style={style}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M6,1 L6,5" id="top2" stroke="#999999" strokeWidth="2" strokeLinecap="round"></path>
      <path d="M14,1 L14,5" id="top" stroke="#999999" strokeWidth="2" strokeLinecap="round"></path>
      <path d="M9,3 L11,3" id="dividertop" stroke="#999999" strokeWidth="2" strokeLinecap="square"></path>
      <path d="M2,8 L18,8" id="divider" stroke="#999999" strokeWidth="2" strokeLinecap="square"></path>
      <path d="M4,3 L4,3 C2.8954305,3 2,3.8954305 2,5 L2,17 C2,18.1045695 2.8954305,19 4,19 L16,19 C17.1045695,19 18,18.1045695 18,17 L18,5 C18,3.8954305 17.1045695,3 16,3" stroke="#999999" strokeWidth="2"></path>
    </g>
  </svg>
)

CalendarIcon.propTypes = {
  style: PropTypes.object
}

export default CalendarIcon



// WEBPACK FOOTER //
// ./src/components/icons/calendar-icon.jsx